import { IconButton } from "@mui/material";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/system";
export const StyledTextField = styled(TextField, {
    shouldForwardProp: (prop) => !["round", "height", "backgroundColor"].includes(prop),
})(({ theme, round, height, backgroundColor }) => ({
    "& .MuiInputBase-root": {
        backgroundColor: "rgb(232, 235, 249)",
        //backgroundColor || theme.palette.background?.lightGray,
        borderRadius: round ? 50 : 10,
        height: height || "auto",
    },
}));
export const ErrorMessage = styled(Typography, {
    shouldForwardProp: (prop) => prop !== "error",
})(({ error }) => ({
    visibility: error ? "inherit" : "hidden",
    fontSize: 12,
    color: "red",
    paddingLeft: 14,
    position: "absolute",
}));
// SuccessText
export const SuccessText = styled(Typography, {
    shouldForwardProp: (prop) => prop !== "successMessage",
})(({ successMessage }) => ({
    visibility: successMessage ? "inherit" : "hidden",
    fontSize: 12,
    paddingLeft: 14,
    color: "green",
}));
export const Label = styled(Typography)(({ theme }) => ({
    //minHeight: 21,
    paddingLeft: 14,
    fontSize: 14,
    color: 'rgb(142, 149, 170)'
}));
export const VisibilityIcon = styled(IconButton)(({ theme }) => ({
    "& svg": {
        color: "#8E95AA",
    },
}));
export const StyledDiv = styled("div")(({ theme }) => ({
    position: "relative",
}));
